import { BaseSearchParam } from "../searchParams/baseSearchParam";
import IsNullOrEmpty from './isNullOrEmpty.ts';

const GenerateQuery = (baseSearchParam: BaseSearchParam) => {
    let query = '?';

    if (!IsNullOrEmpty(baseSearchParam.name))
        query += `name=${encodeURIComponent(baseSearchParam.name!)}&`;

    if (!IsNullOrEmpty(baseSearchParam.sortExpression))
        query += `sortExpression=${encodeURIComponent(baseSearchParam.sortExpression!)}&`;

    if (query == '?')
        return '';

    return query;
}

export default GenerateQuery;